import { Box, CircularProgress } from "@mui/material";
import { InformationsList, useInformation } from "@/features/informations";
import { HeadTitle } from "@/shared";
import { useSnackbar } from "@/shared/hooks";

export default function InformationsPage() {
	const { informations, loading, refetch } = useInformation();
	const { showSuccess, showError } = useSnackbar();

	const handleShowSnackbar = (
		message: string,
		severity: "success" | "error",
		customMessage?: string,
	) => {
		const title = customMessage || message;
		if (severity === "success") {
			showSuccess(title);
		} else {
			showError(title);
		}
	};

	return (
		<Box
			sx={{
				m: 2,
				height: "100%",
				width: "100%",
				display: "flex",
				flexDirection: "column",
			}}
		>
			<HeadTitle pageTitle={"お知らせ管理"} />

			{loading ? (
				<Box
					sx={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						flex: 1,
					}}
				>
					<CircularProgress />
				</Box>
			) : (
				<Box sx={{ display: "flex", justifyContent: "center" }}>
					<InformationsList
						jsonContents={informations}
						onRefresh={refetch}
						onShowSnackbar={handleShowSnackbar}
					/>
				</Box>
			)}
		</Box>
	);
}
